import React from "react";
import { Badge, makeStyles, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { JobStatus } from "../../models/Job";

const useStyles = makeStyles({
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
  },
});

interface ReindexStatusBadgeProps {
  status: JobStatus;
  showText?: boolean;
}

export const ReindexStatusBadge: React.FC<ReindexStatusBadgeProps> = ({
  status,
  showText = true,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const getStatusConfig = (status: JobStatus) => {
    switch (status) {
      case JobStatus.NotStarted:
        return {
          color: "subtle" as const,
          text: t("reindexStatus.notStarted"),
        };
      case JobStatus.Running:
        return {
          color: "informative" as const,
          text: t("reindexStatus.running"),
        };
      case JobStatus.Completed:
        return {
          color: "success" as const,
          text: t("reindexStatus.completed"),
        };
      case JobStatus.Failed:
        return {
          color: "severe" as const,
          text: t("reindexStatus.failed"),
        };
      case JobStatus.Canceled:
        return {
          color: "severe" as const,
          text: t("reindexStatus.canceled"),
        };
      default:
        return {
          color: "subtle" as const,
          text: status,
        };
    }
  };

  const { color, text } = getStatusConfig(status);

  return (
    <div className={classes.statusBadge}>
      <Badge appearance="filled" color={color}>
        {showText && text}
      </Badge>
    </div>
  );
};
